export default __webpack_public_path__ + "static/media/logoNavbar.191a465a.svg";